import React from 'react';
import { SyncingLine } from '@dropbox/dig-icons/assets';
import { DebugPanel, PanelComponent } from './debug-panel';
import { useEventListener } from 'js/sign-components/common/hooks';
import { AppActionLogEntry } from 'hello-react/web-app-client';
import Table from 'hellospa/foundation/tables/table';
import { Button } from '@dropbox/dig-components/buttons';
import styles from './app-actions-panel.scss';


const copy = async (item: any) => {
  navigator.clipboard.writeText(JSON.stringify(item, null, 2));
};


const AppActionsPanel: PanelComponent = ({ isOpen }) => {
  const [log, setLog] = React.useState([] as AppActionLogEntry[]);
  useEventListener(document.body, 'app-action-log', (event) => {
    if (event instanceof CustomEvent) {
      const log: AppActionLogEntry[] = event.detail ?? [];
      setLog(log);
    }
  });

  if (!isOpen) {
    return null;
  }

  return (
    <React.Fragment>
      <DebugPanel.SectionHeader>
        AppActions

        <Button variant='outline' onClick={() => copy(log)}>
          Copy log
        </Button>
      </DebugPanel.SectionHeader>

      <Table currentPage={1}>
        <Table.Head className={styles.head}>
          <Table.Row>
            <Table.Heading>
              AppAction call
            </Table.Heading>
            <Table.Heading>
              Response
            </Table.Heading>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {log.map((item) => {
            return (
              <Table.Row key={item.id}>
                <Table.Data>
                  {item.timestamp}
                  <pre>
                    {item.name}(...{JSON.stringify(item.args, null, 2)})
                  </pre>
                  <Button variant='outline' onClick={() => copy(item.result)}>A
                    Copy Response
                  </Button>
                </Table.Data>
                <Table.Data>
                  <pre>
                    {JSON.stringify(item.result, null, 2)}
                  </pre>
                </Table.Data>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </React.Fragment >
  );
};

export const appActionsPanel = process.env.NODE_ENV !== 'production' && (
  <DebugPanel
    Component={AppActionsPanel}
    updateWhileClosed={true}
    icon={SyncingLine}
    title="App Actions" />
);
